module.exports = __webpack_public_path__ + "static/media/(LH)-Artesanato-04.11509014.jpg";